class NeloHeaders {
    id;
    timeZone;
    acceptLanguage;
    platform;
    systemVersion;
    manufacturer;
    model;
    version;
    versionCode;
    versionVariation;
    constructor(deviceInfo) {
        this.id = deviceInfo.id;
        this.timeZone = deviceInfo.timeZone;
        this.acceptLanguage = deviceInfo.acceptLanguage;
        this.platform = deviceInfo.platform;
        this.systemVersion = deviceInfo.systemVersion;
        this.manufacturer = deviceInfo.manufacturer;
        this.model = deviceInfo.model;
        this.version = deviceInfo.version;
        this.versionCode = deviceInfo.versionCode;
        this.versionVariation = deviceInfo.versionVariation;
    }
    async buildHeaders() {
        const deviceHeaders = {
            "Accept-Language": this.acceptLanguage,
            "x-device-id": this.id,
            "x-device-platform": this.platform,
            "x-device-manufacturer": this.manufacturer,
            "x-device-model": this.model,
            "x-app-version-code": this.versionCode,
            "x-app-version": this.version,
            "x-device-timezone": this.timeZone,
        };
        if (this.versionVariation) {
            deviceHeaders["x-app-version-code-variation"] = this.versionVariation;
        }
        if (this.systemVersion) {
            deviceHeaders["x-device-os-version"] = this.systemVersion;
        }
        return deviceHeaders;
    }
    async getDeviceHeaders() {
        return await this.buildHeaders();
    }
    async getHeaders() {
        const deviceHeaders = await this.getDeviceHeaders();
        return new Headers({
            Accept: "application/json",
            ...deviceHeaders,
        });
    }
}
export default NeloHeaders;
